import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/common/Reveal";
import { SectionLabel } from "../components/common/SectionLabel";
import { TechCard } from "../components/common/TechCard";
import { useSection } from "../context/SiteContentContext";
import SEO from "../components/common/SEO";
const DEFAULT_SERVICES = [
    {
        n: "01",
        title: "Sensor Integration & Calibration",
        body: "Integration of photonic LiDAR, hyperspectral and multispectral payloads on airborne, terrestrial, and orbital platforms. Radiometric and geometric calibration, co-registration, and time synchronization.",
        deliverables: ["Integration plan", "Calibration report", "Flight/mission checklists"],
    },
];

export default function Services() {
    const SERVICES = useSection("services", DEFAULT_SERVICES);
    return (
        <>
            <SEO
                title="Services — Engagements, Engineered · Skovomax"
                description="Sensor integration & calibration, point-cloud & imagery processing, GeoAI model development, hazard & decision systems, research partnerships, and custom photonic system design."
            />
            <section className="pt-28 pb-16 border-b border-white/10 relative overflow-hidden">
                <div className="absolute inset-0 photonic-grid opacity-20 pointer-events-none" />
                <div className="max-w-[1440px] mx-auto px-6 md:px-10">
                    <Reveal>
                        <SectionLabel label="Services / 05" />
                        <h1 className="font-serif-display text-6xl md:text-8xl leading-[0.95] tracking-tight max-w-5xl">
                            Engagements, <br />
                            <span className="italic text-white/70">engineered.</span>
                        </h1>
                    </Reveal>
                </div>
            </section>

            <section className="py-24">
                <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6">
                    {SERVICES.map((s, i) => (
                        <Reveal delay={i * 70} key={s.n}>
                            <TechCard className="!p-10 h-full">
                                <div className="flex items-center justify-between mb-6">
                                    <div className="font-mono-tech text-[11px] tracking-[0.22em] text-[var(--accent-indigo)]">
                                        {s.n} / Service
                                    </div>
                                </div>
                                <h3 className="font-serif-display text-3xl leading-tight mb-4">{s.title}</h3>
                                <p className="text-white/60 leading-relaxed mb-6">{s.body}</p>
                                <div className="tech-label mb-3">Deliverables</div>
                                <ul className="space-y-2 text-white/70 font-mono-tech text-xs">
                                    {s.deliverables.map((d) => (
                                        <li key={d}>· {d}</li>
                                    ))}
                                </ul>
                            </TechCard>
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="py-24 border-t border-white/10 bg-[#0a0a18]">
                <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
                    <h2 className="font-serif-display text-5xl md:text-6xl leading-[1.05] tracking-tight max-w-2xl">
                        Have a measurement problem?
                    </h2>
                    <Link to="/contact" className="btn-primary" data-testid="services-cta">Start an engagement</Link>
                </div>
            </section>
        </>
    );
}
